
import { defineComponent, ref, watchEffect, computed } from "vue";
import { Field, ErrorMessage } from "vee-validate";
import { useStore } from "vuex";
import Editor from "@tinymce/tinymce-vue";
import DropDownSection from "@/components/sections/DropDownSections.vue";

interface IStep3 {
  includeSomething: string;
  volume: string;
  frequency: string;
  sampleDescription: string;
}

export default defineComponent({
  name: "step-3",
  components: {
    Field,
    ErrorMessage,
    Editor,
    DropDownSection,
  },
  setup() {
    const store = useStore();
    const listDropDownSections = [
      {
        title: "Information",
        descriptions: [{ description: " Some Information" }],
      },
    ];
    const step3 = ref<IStep3>({
      includeSomething: "0",
      volume: "",
      frequency: "",
      sampleDescription: "",
    });

    const currentEditorToken = computed(() => {
      return store.getters.currentEditorToken;
    });

    watchEffect(() => {
      const data = store.getters.currentRisk;
      if (data === null || data.data === undefined) return;
      step3.value.includeSomething = data.data.includeSomething ? "1" : "0";
      step3.value.volume = data.data.volume == null ? "" : data.data.volume;
      step3.value.frequency =
        data.data.frequency == null ? "" : data.data.frequency;
      step3.value.sampleDescription = data.data.sampleDescription || "";
    });

    return {
      step3,
      Editor,
      listDropDownSections,
      currentEditorToken,
    };
  },
});
